import {
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
} from '@mui/material';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import CustomButton from '../elements/CustomButton';
import InputField from '../elements/InputField';

const ResetPasswordForm = ({ onSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleClickShowPassword = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else if (field === 'passwordConfirmation') {
      setShowConfirmation(!showConfirmation);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Formik
        initialValues={{
          password: '',
          passwordConfirmation: '',
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .required('New Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
              'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
            ),
          passwordConfirmation: Yup.string()
            .required('Confirm Password is required')
            .oneOf([Yup.ref('password'), null], 'New Password must match'),
        })}
        onSubmit={onSubmit}>
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Stack spacing={1}>
                  <InputField
                    label={'Password'}
                    fullWidth
                    error={Boolean(touched.password && errors.password)}
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={values.password}
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleClickShowPassword('password')}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="large">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="********"
                    inputProps={{}}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Confirm Password"
                    id="passwordConfirmation"
                    type={showConfirmation ? 'text' : 'password'}
                    value={values.passwordConfirmation}
                    name="passwordConfirmation"
                    fullWidth
                    error={Boolean(
                      touched.passwordConfirmation &&
                        errors.passwordConfirmation
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="********"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password confirmation visibility"
                          onClick={() => handleClickShowPassword('passwordConfirmation')}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="large">
                          {showConfirmation ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Stack>
              </Grid>
              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <CustomButton buttonLabel={'Update'} />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ResetPasswordForm;
